import React, { memo } from "react"
import { Text, Flex } from "@chakra-ui/react"

import type { ProductCombinedProps } from "@root/types/global"

type Props = {
  product: ProductCombinedProps
  fabric?: string
  fabricLocale?: string
}

export const ProductContentFabric: React.FC<Props> = memo(({ fabric, fabricLocale }) => {
  return (
    <Flex>
      {fabric && (
        <Text letterSpacing="generous" size="sm" color="grey.text">
          {fabricLocale?.replace("{fabric}", fabric)}
        </Text>
      )}
    </Flex>
  )
})
